import type { RestrictionTypeEnum } from "~/api/generated/model";
import type { LayerRegistry } from "~/components/map/registry/mapLayer";
import { RESTRICTION_LAYER_REGISTRY } from "../../ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/-components/restrictionsLayersConfig";
import {
  PROPERTY_LAYER_REGISTRY as catalog,
  PROPERTY_RESTRICTION_LAYER_IDS,
} from "./generated/propertyLayerRegistry";

const additionalLayers = RESTRICTION_LAYER_REGISTRY.layers.filter(
  (layer) => !PROPERTY_RESTRICTION_LAYER_IDS[layer.id],
);

export const propertyRestrictionLayerId = (type: RestrictionTypeEnum) =>
  PROPERTY_RESTRICTION_LAYER_IDS[type] ?? type;

export const PROPERTY_LAYER_REGISTRY: LayerRegistry = {
  layers: [...catalog.layers, ...additionalLayers],
  groups: [
    ...catalog.groups,
    {
      id: "screened-restrictions",
      labelKey: "properties:map.screenedRestrictions",
      layerIds: additionalLayers.map((layer) => layer.id),
    },
  ],
};
